import React, { useMemo, useRef } from "react";

import { Box } from "@chakra-ui/react";
import { IVaultSavings } from "api/individual-savings/types";
import { ReactComponent as MenuDotsIcon } from "assets/icons/menu-dots.svg";
import {
  IMoreQuickActionItem,
  TQuickActionType,
} from "features/individuals/individual-details/more-quick-actions/types";
import {
  individualDetailsQuickActionBtnCss3,
  moreQuickActionsDropDownPopUpMenuContentCss,
} from "features/individuals/individual-details/styles";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";

import { DropDown } from "ui/dropdown";
import { IDropDownRef } from "ui/dropdown/types";
import { Paragraph3 } from "ui/typography";

const textColorMap: Record<TQuickActionType, string> = {
  regular: "#1A202C",
  disabled: "#344054",
  danger: "#DC2626",
};
const DROP_DOWN_WIDTH = 240;

interface INewMoreQuickActionsProps {
  individualsSavingDetails: IVaultSavings;
}

export const MoreQuickActions = (props: INewMoreQuickActionsProps) => {
  const { individualsSavingDetails } = props;
  const navigate = useNavigate();
  const dropDownRef = useRef<IDropDownRef | null>(null);

  const handleToggleDropDown = () => {
    if (!dropDownRef.current) return;
    dropDownRef.current.handleToggleDropdown();
  };

  const quickActions: IMoreQuickActionItem[] = useMemo(() => {
    if (!individualsSavingDetails) return [];

    return [
      {
        label: "View Savings Details",
        isDisabled: false,
        handleQuickActionItemClick: () => {
          handleToggleDropDown();
          navigate(
            `${ROUTES.INDIVIDUALS_VAULT_SAVINGS_PAGE}/${individualsSavingDetails.id}/view-savings-details`
          );
        },
        type: "regular",
      },
      {
        label: "View Saving's History",
        isDisabled: false,
        handleQuickActionItemClick: () => {
          handleToggleDropDown();
          navigate(
            `${ROUTES.INDIVIDUALS_VAULT_SAVINGS_PAGE}/${individualsSavingDetails?.id}/view-savings-history`
          );
        },
        type: "regular",
      },
    ];
  }, [individualsSavingDetails]);

  return (
    <>
      <DropDown
        dropDownWidth={DROP_DOWN_WIDTH}
        dropDownBtnContent={
          <>
            <MenuDotsIcon className="w-4 h-4" />
          </>
        }
        allowOutSideClick
        customDropDownButtonCss={individualDetailsQuickActionBtnCss3}
        dropDownPopUpMenuContentCss={
          moreQuickActionsDropDownPopUpMenuContentCss
        }
        ref={dropDownRef}
      >
        <Box className="flex flex-col">
          {quickActions.map(
            ({ label, isDisabled, handleQuickActionItemClick, type }, idx) => {
              return (
                <Box
                  className={`h-10 py-[10px] flex items-center ${isDisabled ? "cursor-not-allowed" : "cursor-pointer"}`}
                  key={idx}
                  onClick={handleQuickActionItemClick}
                >
                  <Paragraph3
                    textColor={textColorMap[type]}
                    lineHeight="20px"
                    fontWeight="600"
                  >
                    {label}
                  </Paragraph3>
                </Box>
              );
            }
          )}
        </Box>
      </DropDown>
    </>
  );
};
